
  <section id="article" class="services articlecontainer-main space-comman-articalsetino pb-2">
    <div class="pad_15">
    <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title article-article">

            <p class="pt-3" style="color: #000;">Check Out Our Latest Article</p>
        </div>

      
        <div class="row">
            <owl-carousel [options]="SlideOptions2" [carouselClasses]="['owl-theme', 'sliding']">
                <div class="item" *ngFor="let img of Images2">
                    
                    <div class=" articale-container d-flex align-items-stretch mt-4 aos-init aos-animate"
                data-aos="zoom-in" data-aos-delay="100">
                <div class="image-box_new">
                    <div class="icon-container icon-container2"><img src="{{img.img}}"
                            style="border-top-left-radius: 20px; border-top-right-radius:20px;"></div>
                    <div class="text-container">
                        <h4 style="line-height: 21px;"><a href="" class="image-box-ancher">{{img.title}}</a></h4>
                        <p class="text_jus">{{img.text}}</p>
                      
                    </div>
                </div>
            </div>
                </div>
            </owl-carousel>
        </div>

        

       
       


    </div>
    </div>
</section>
